export const capitalizeFirstLetter = (str: string) =>
  str && `${str.charAt(0).toUpperCase()}${str.slice(1)}`;

export const transformStringToSnakeCase = (str: string) =>
  str
    .toLowerCase()
    .replaceAll(',', '')
    .replaceAll('.', '')
    .replaceAll("'", '')
    .split(' ')
    .join('_');
